<template>
    <v-container>
        <v-data-table :headers="headers"
                      :items="getSortedItems"
                      item-value="name"
                      dense disable-pagination class="progresstable elevation-1"
      :items-per-page="-1">
            <template v-slot:[`item.trend`]="{ item }">
                <v-icon v-if="item.trend > 0" color="green">mdi-arrow-up</v-icon>
                <v-icon v-else-if="item.trend < 0" color="red">mdi-arrow-down</v-icon>
                <span>{{ Math.abs(item.trend) }}%</span>
            </template>

            <template v-slot:[`item.satisfaction`]="{ item }">
                <v-progress-linear :value="item.satisfaction"
                                   color="#79C086" backgroundColor="transparent"
                                   height="20"
                                   rounded>
                    {{ item.satisfaction }}%
                </v-progress-linear>
            </template>

            <template v-slot:[`item.distortion`]="{ item }">
                <v-progress-linear :value="item.distortion"
                                   color="#CA4A56" backgroundColor="transparent"
                                   height="20"
                                   rounded>
                    {{ item.distortion }}%
                </v-progress-linear>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
    export default {
        props: {
    value: {
        type: Array,
default: () => []
    },

    },
        data() {
            return {
                headers: [
                    { text: 'معدل انتشار مظاهر التشوه البصري', value: 'distortion', align: 'center', width: '200px' },
                    { text: 'الأمانة', value: 'name', align: 'center', width: '200px' },
                    { text: 'معدل الرضا عن الجهود البلدية لمعالجة مظاهر التشوه البصري', value: 'satisfaction', align: 'center',width:'200px' },
                    { text: 'حجم الفجوة', value: 'trend', align: 'center', width: '200px' },
                ],
                /*items: [
                    { name: 'أمانة منطقة القصيم', trend: -33, satisfaction: 49, distortion: 82 },
                    { name: 'أمانة منطقة حائل', trend: 30, satisfaction: 81, distortion: 51 },
                    { name: 'أمانة الأحساء', trend: 25, satisfaction: 81, distortion: 56 },
                    { name: 'أمانة المدينة المنورة', trend: 17, satisfaction: 74, distortion: 57 },
                    { name: 'أمانة محافظة الطائف', trend: 15, satisfaction: 74, distortion: 58 },
                    { name: 'أمانة المنطقة الشرقية', trend: 16, satisfaction: 72, distortion: 56 },
                    { name: 'أمانة منطقة عسير', trend: 14, satisfaction: 72, distortion: 58 },
                    { name: 'أمانة الحدود الشمالية', trend: 15, satisfaction: 71, distortion: 56 },
                    { name: 'أمانة منطقة الباحة', trend: 15, satisfaction: 70, distortion: 55 },
                    { name: 'أمانة منطقة جازان', trend: 10, satisfaction: 69, distortion: 59 },
                    { name: 'أمانة منطقة الرياض', trend: 11, satisfaction: 69, distortion: 58 },
                    { name: 'أمانة حفر الباطن', trend: 10, satisfaction: 69, distortion: 59 },
                    { name: 'أمانة منطقة الجوف', trend: 9, satisfaction: 69, distortion: 59 },
                    { name: 'أمانة منطقة تبوك', trend: 9, satisfaction: 68, distortion: 59 },
                    { name: 'أمانة منطقة نجران', trend: 7, satisfaction: 68, distortion: 61 },
                    { name: 'أمانة العاصمة المقدسة', trend: 7, satisfaction: 66, distortion: 59 },
                    { name: 'أمانة محافظة جدة', trend: 2, satisfaction: 64, distortion: 62 }
                ]*/
            }
        },
        computed: {
            getSortedItems() {
                var items = this.value
                return items.sort((a, b) => b.trend - a.trend)
            }
        },
        methods: {
            getGradientColor(value) {
                let startColor = [229, 242, 231] // RGB of #E5F2E7
                let endColor = [121, 192, 134]  // RGB of #79C086

                let r = Math.round(startColor[0] + (endColor[0] - startColor[0]) * (value / 100))
                let g = Math.round(startColor[1] + (endColor[1] - startColor[1]) * (value / 100))
                let b = Math.round(startColor[2] + (endColor[2] - startColor[2]) * (value / 100))

                return `rgb(${r}, ${g}, ${b})`
            }
        }
    }
</script>

<style scoped>
    /* Custom Styling */
    .progresstable{
        width:auto
    }
    .progresstable td{
        width:25vw
    }
</style>
